import { useMemo } from "react";
import { FormGroup } from "reactstrap";
import { SelectPicker } from "rsuite";

import useQueriedRecords from "../../api/api-hooks/records/useQueriedRecords";
import RequiredTitle from "../../elements/RequiredTitle";

interface Props {
  onChange: (value: any) => void;
  value: any;
  required: boolean;
}

const DocumentPicker = ({ onChange, value, required }: Props) => {
  const { records, recordsLoading } = useQueriedRecords({
    moduleAPIName: "Documents",
    query: {
      Fields: ["_RecordName", "id"],
      Filters: [],
      OrderBy: {
        Field: "Created",
        Direction: "DESC",
      },
      Limit: {
        Count: 200,
      },
    },
  });

  const pickerData = useMemo(() => {
    if (recordsLoading) return [];

    let out = [
      {
        label: "Create A New Document",
        value: "new",
        type: "New Document",
      },
    ];

    if (!records || !records?.length) return out;

    const add = records.map((doc: any) => ({
      label: doc?._RecordName,
      value: doc?.id,
      type: "Existing Documents",
    }));

    out = out.concat(add);

    return out;
  }, [records, recordsLoading]);

  return (
    <FormGroup>
      {required ? (
        <RequiredTitle title="Select A Document or Create New" size="md" />
      ) : (
        <h5>Select A Document or Create New</h5>
      )}
      <SelectPicker
        loading={recordsLoading}
        data={pickerData}
        style={{ width: "100%" }}
        placeholder="Select Document Or Create"
        onChange={onChange}
        onClean={() => onChange("")}
        value={value}
        groupBy="type"
        preventOverflow
      />
    </FormGroup>
  );
};

export default DocumentPicker;
